import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';

export interface DiaSemana {
  fecha: string;
  dia: string;
  total_citas: number;
  laborable?: boolean;
}

interface Respuesta {
  lunes: string;
  dias: DiaSemana[];
  totalSemanaAnterior: number;
}

const toISO = (d: Date) => {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export const useCitasSemana = (empresaId: string, offsetSemanas: number) => {
  const [loading, setLoading] = useState(true);
  const [dias, setDias] = useState<DiaSemana[]>([]);
  const [lunes, setLunes] = useState<string>('');
  const [totalSemanaAnterior, setTotalSemanaAnterior] = useState(0);

  useEffect(() => {
    if (!empresaId) return;
    let cancelado = false;

    const fecha = new Date();
    fecha.setDate(fecha.getDate() + offsetSemanas * 7);

    const load = async () => {
      setLoading(true);
      const { data, error } = await supabase.rpc('get_citas_semana', {
        p_empresa: empresaId,
        p_fecha: toISO(fecha),
      });
      if (cancelado) return;

      if (error) {
        Sentry.captureException(error, { extra: { empresaId, offsetSemanas } });
        setLoading(false);
        return;
      }

      const res = data as Respuesta;
      setDias(res?.dias ?? []);
      setLunes(res?.lunes ?? '');
      setTotalSemanaAnterior(Number(res?.totalSemanaAnterior ?? 0));
      setLoading(false);
    };

    load();
    return () => {
      cancelado = true;
    };
  }, [empresaId, offsetSemanas]);

  return { loading, dias, lunes, totalSemanaAnterior };
};
